import { render, staticRenderFns } from "./floor-style-1.vue?vue&type=template&id=b041940a"
import script from "./floor-style-1.vue?vue&type=script&lang=js"
export * from "./floor-style-1.vue?vue&type=script&lang=js"
import style0 from "./floor-style-1.vue?vue&type=style&index=0&id=b041940a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports